<template>
  <div class="loading">
        <span></span>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.loading {
            /* top: 0; */
            z-index: 1000;
            width: 100%;
            background: rgba(255, 255, 255, 0.096);
            backdrop-filter: blur(2px);
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 101;
            height: 100%;
            border-radius: 10px;
        }

        span {
            display: block;
            width: 60px;
            height: 60px;
            margin: 0 auto;
            border: 3px solid transparent;
            border-top-color: #fff;
            border-bottom-color: #fff;
            border-radius: 50%;
            animation: spin 3s infinite ease;
        }

        @keyframes spin {
            to {
                transform: rotateZ(360deg);
            }
        }
</style>